import type { AppDispatch } from '../typings'
import { useDispatch } from 'react-redux'

export const useAppDispatch = () => useDispatch() as AppDispatch
